<template minapp="mpx" xlang="wxml">
  <view class="guide-tips-wrap" wx:style="{{wrapStyle}}">
    <image src="{{icon}}" class="icon"/>
    <view class="title" wx:style="{{titleStyle}}">
      <rich-text nodes="{{title}}"></rich-text>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props:{
      pageType: {
        type: String,
        value: 'search', // detail // makeOrderDetail
      },
      trainInfo:{
        type: Object | String
      }
    },
    data: {
      icon:'https://ut-static.udache.com/webx/sfc/lEvwJSaipuIHTs8-arRoK.png',
    },
    computed: {
      title(){
        switch (this.pageType) {
          case 'search':
            return [{
              type: 'node',
              name: 'span',
              attrs: { style: `color: #000000` },
              children: [{ type: 'text', text:'提前预约' }]
            },{
              type: 'node',
              name: 'span',
              attrs: { style: `color: #FF6400` },
              children: [{ type: 'text', text:'开售即抢' }]
            },{
              type: 'node',
              name: 'span',
              attrs: { style: `color: #000000` },
              children: [{ type: 'text', text:' 先人一步抢到票' }]
            }]
          case 'detail':
          case 'makeOrderDetail':
            let msg = this.trainInfo?.sale_msg || ''
            const list = msg?.split('#') || []
            list[0] = this.getTemplate('#000000', list?.[0])
            list[1] = this.getTemplate('#FF4129', list?.[1])
            list[2] = this.getTemplate('#000000', list?.[2])
            return list 
        }
      },
      wrapStyle(){
        switch (this.pageType) {
          case 'search':
            return ''
          case 'detail':
            return 'margin-left: -14px;margin-right: -14px;margin-top: -14px;border-radius: 8px 8px 0 0; margin-bottom: 8px;'
          case 'makeOrderDetail':
            return 'border-radius: 8px 8px 0 0;'
        }
      },
      titleStyle(){
        switch (this.pageType) {
          case 'search':
            return ''
          case 'detail':
            return 'font-family: PingFangSC-Regular;'
        }
      }
    },
    methods: {
      getTemplate(color, text) {
        return {
          type: 'node',
          name: 'span',
          attrs: { style: `color: ${color}` },
          children: [{ type: 'text', text: text || '' }]
        }
      }
    }
  })
</script>

<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .guide-tips-wrap
    background: linear-gradient(0deg, rgba(255, 89, 0, 0.05), rgba(255, 89, 0, 0.05)), #FFFFFF;
    box-sizing: border-box;
    border: 1.5px solid #FFFFFF;
    display: flex;
    align-items: center;
    border-radius: 12px;
    padding: 4px 0 4px 0;
    .icon
      width: 36px;
      height: 36px; 
      margin-right: 12rpx;
      margin-left: 21px;
    .title
      font-family: PingFangSC-Medium;
      font-size: 14px;
      font-weight: normal;
      line-height: 16px;
      letter-spacing: 0px;


</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>